module.exports = __webpack_public_path__ + "assets/img/output_json.e01c4373.png";